module.exports = __webpack_public_path__ + "static/26-7d7cec24e1c8f00086cc8d4a8e95573a.jpg";